<template>
  <div v-if="visible" class="about-overlay" @click.self="handleClose">
    <div class="about-container">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </button>
      
      <!-- 标题 -->
      <div class="about-header">
        <h2 class="about-title">{{ $t('navTab.aboutUs') || 'About Us' }}</h2>
      </div>
      
      <!-- 内容显示 -->
      <div class="about-content">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
          <i class="el-icon-loading" style="font-size: 32px; color: var(--primary-color, #0156DC);"></i>
          <div style="margin-top: 10px;">{{ $t('common.loading') || '加载中...' }}</div>
        </div>
        
        <!-- 内容显示 -->
        <template v-else>
          <!-- 优先显示后端获取的内容 -->
          <template v-if="aboutData && aboutData.info">
            <div class="about-section" v-if="aboutData.title">
              <h3 class="section-title">{{ aboutData.title }}</h3>
            </div>
            <div class="about-text" v-html="aboutData.info"></div>
          </template>
          
          <!-- 默认内容（如果没有从后端获取到） -->
          <div v-else class="default-content">
            <div class="about-section">
              <h3 class="section-title">FoGold</h3>
              <p class="section-text">
                The FoGold Stock Exchange, located in Zurich, is Switzerland's primary exchange for stocks, bonds, and derivatives such as options. Jointly issued by major exchange groups in the New York International Financial Center, FoGold is one of the world's most technologically advanced stock exchanges.
              </p>
            </div>
            
            <div class="about-section">
              <h3 class="section-title">Our History</h3>
              <p class="section-text">
                In 1995, it was formed through the merger of three century-old Swiss stock exchanges in Zurich, Basel, and Geneva. The Berne Stock Exchange still exists in the Swiss capital. The strength of Switzerland's financial center, its leading position in cross-border private asset management, the high level of financing and placement capabilities enjoyed by Swiss banks, and Switzerland's overall attractiveness as a business location make the Swiss Stock Exchange highly attractive to both domestic and international companies.
              </p>
            </div>
            
            <div class="about-section">
              <h3 class="section-title">Our Services</h3>
              <p class="section-text">
                Backed by the strength of the Swiss financial market, the Swiss Stock Exchange has a globally focused strategy. Through trading partnerships with renowned international financial center groups, FoGold provides first-class securities trading services. Not only is its extensive product offering impressive, but its fully integrated and automated trading, clearing, and settlement systems are also unique.
              </p>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getContentsById } from "@/api/market.js";

export default {
  name: 'AboutUsDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      aboutData: null
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadAboutData();
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    
    loadAboutData() {
      // 从后端加载关于我们的内容
      // 使用固定的ID: 1728470788132061185
      this.loading = true;
      
      getContentsById('1728470788132061185').then(res => {
        if (res && res.result) {
          this.aboutData = res.result;
        }
        this.loading = false;
      }).catch(err => {
        console.error('加载关于我们内容失败:', err);
        this.loading = false;
        // 出错时使用默认内容，不需要额外处理
      });
    }
  }
};
</script>

<style scoped>
/* 遮罩层 */
.about-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: all 0.3s ease;
}

/* 容器 */
.about-container {
  width: 900px;
  max-width: 95vw;
  max-height: 85vh;
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  position: relative;
  padding: 40px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: none;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.close-btn i {
  font-size: 18px;
}

/* 标题区域 */
.about-header {
  margin-bottom: 30px;
  text-align: center;
}

.about-title {
  font-size: 28px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  transition: color 0.3s ease;
}

/* 加载状态 */
.loading-container {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

/* 内容区域 */
.about-content {
  color: var(--text-primary);
}

.about-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 15px;
  transition: color 0.3s ease;
}

.section-text {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-primary);
  margin-bottom: 15px;
  text-align: justify;
  transition: color 0.3s ease;
}

.default-content {
  padding: 10px 0;
}

/* HTML内容适配 */
.about-text {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-primary);
  transition: color 0.3s ease;
}

.about-text :deep(*) {
  color: var(--text-primary) !important;
}

.about-text :deep(h1),
.about-text :deep(h2),
.about-text :deep(h3),
.about-text :deep(h4),
.about-text :deep(h5),
.about-text :deep(h6) {
  color: var(--text-primary);
  margin: 20px 0 15px 0;
}

.about-text :deep(p) {
  margin-bottom: 15px;
  line-height: 1.8;
}

.about-text :deep(a) {
  color: var(--primary-color, #0156DC);
}

/* 滚动条样式 */
.about-container::-webkit-scrollbar {
  width: 6px;
}

.about-container::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 3px;
}

.about-container::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 3px;
}

.about-container::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

/* 响应式 */
@media (max-width: 768px) {
  .about-container {
    width: 95vw;
    padding: 20px;
  }
  
  .about-title {
    font-size: 24px;
  }
  
  .section-title {
    font-size: 18px;
  }
  
  .section-text,
  .about-text {
    font-size: 14px;
  }
}
</style>

